/**
 * [zgłoszenie właściciela 2026-09-16] SLA OBOWIĄZUJĄCE KATEGORII — własne albo z okna/grupy.
 *
 * „Jeżeli dodaję jakieś zgłoszenia pod grupą i nie ustawię ręcznie SLA, to znaczy, że dziedziczą
 *  one z grupy."
 *
 * BYŁO ŹLE: ekrany czytały wyłącznie `kategoria.reactionTime`. Kategoria utworzona kreatorem
 * wewnątrz okna własnych czasów NIE MA — więc pracownik przy wyborze takiej kategorii nie widział
 * żadnego terminu, a priorytet zgłoszenia liczył się tak, jakby kategoria nic o SLA nie mówiła.
 *
 * TERAZ: czytamy wartość OBOWIĄZUJĄCĄ, którą wylicza serwer (`SlaKategorii` → `effective*`).
 * Zapas na starsze odpowiedzi API jest celowy — front świeższy od serwera zachowa się dokładnie
 * jak przed zmianą, zamiast pokazać pustkę.
 *
 * Osobny moduł, a nie funkcja w oknie agenta: korzystają z tego DWA okna zgłoszenia (pracownika
 * i agenta), a okno pracownika nie ma powodu wciągać do swojej paczki całego okna agenta.
 */

/** Czas reakcji, który realnie obowiązuje tę kategorię; null, gdy nie ma żadnego. */
export const czasReakcjiKategorii = (kategoria) =>
    (kategoria?.effectiveReactionTime || kategoria?.reactionTime || "").trim() || null;

/** Czas rozwiązania, który realnie obowiązuje tę kategorię; null, gdy nie ma żadnego. */
export const czasRozwiazaniaKategorii = (kategoria) =>
    (kategoria?.effectiveResolutionTime || kategoria?.resolutionTime || "").trim() || null;

/**
 * [zgłoszenie właściciela 2026-09-17] „napraw dziedziczenie priorytetu z okna."
 *
 * ETYKIETA priorytetu, która obowiązuje kategorię — własna albo z okna („Krytyczny", „Wysoki",
 * „Średni", „Niski", „Standard"). Serwer liczy ją tą samą regułą, co czasy (`SlaKategorii`).
 *
 * ⚠️ To jest ETYKIETA DO POKAZANIA, nie priorytet zgłoszenia. Zamiana etykiety na wartość kanoniczną
 * (Low/Normal/High/Critical) ma swoją kolejność źródeł i mieszka w `priorytetZKategorii`.
 */
export const etykietaPriorytetuKategorii = (kategoria) =>
    (kategoria?.effectivePriority || kategoria?.priority || "").trim() || null;

/**
 * [zgłoszenie właściciela 2026-09-17] BRAMKA PASKA SLA W OKNIE PRACOWNIKA — jako funkcja, nie warunek
 * zaszyty w renderze.
 *
 * BYŁO ŹLE: pasek chował się, gdy kategoria nie miała WŁASNEJ etykiety priorytetu — razem z czasami.
 * Kategorie z kreatora własnej etykiety nie mają, więc pracownik nie widział ANI priorytetu, ANI czasów,
 * choć okno miało jedno i drugie. Poprawka czasów z 16.09 była w tym miejscu martwa: wyliczała wartości,
 * których nic nie pokazywało.
 *
 * Reguła jest jedna: pasek pojawia się, gdy obowiązuje CHOĆ JEDNA z trzech wartości — własna albo z okna.
 * Stoi tutaj, a nie w renderze, żeby dało się ją sprawdzić bez montowania całego okna zgłoszenia.
 *
 * @returns {{priorytet: string|null, reakcja: string|null, rozwiazanie: string|null}|null}
 */
export const plakietkiSlaKategorii = (kategoria) => {
    const priorytet = etykietaPriorytetuKategorii(kategoria);
    const reakcja = czasReakcjiKategorii(kategoria);
    const rozwiazanie = czasRozwiazaniaKategorii(kategoria);
    if (!priorytet && !reakcja && !rozwiazanie) return null;
    return { priorytet, reakcja, rozwiazanie };
};
